import { useEffect, useState } from 'react';

/**
 * 모바일(스마트폰) 여부. 리사이즈/회전에 반응.
 * - 폭 기준: max-width ≤ breakpoint(기본 768px)
 * - OR 터치 기기: (pointer: coarse) and (hover: none)
 *   → Outlook/Teams 모바일 앱의 임베드 웹뷰는 뷰포트 폭을 데스크톱급으로 보고할 수 있어
 *     폭만으로는 PC로 오판됨. 터치+hover없음으로 폰 웹뷰를 보강 감지(데스크톱 앱 임베드는 hover/fine pointer라 제외).
 */
export function useIsMobile(breakpoint = 768): boolean {
  const query = `(max-width: ${breakpoint}px), (pointer: coarse) and (hover: none)`;
  const [mobile, setMobile] = useState<boolean>(
    () => typeof window !== 'undefined' && window.matchMedia(query).matches,
  );

  useEffect(() => {
    const mq = window.matchMedia(query);
    const handler = (): void => setMobile(mq.matches);
    handler();
    mq.addEventListener('change', handler);
    return () => mq.removeEventListener('change', handler);
  }, [query]);

  return mobile;
}
